import _extends from 'babel-runtime/helpers/extends';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _get from 'lodash/get';
import _isPlainObject from 'lodash/isPlainObject';
import { getNoninteractiveTagList, createNoninteractiveTag, updateNoninteractiveTag } from '@/api/system/noninteractive-tag.js';
import { getInteractiveTagList, createInteractiveTag, updateInteractiveTag } from '@/api/system/interactive-tag.js';
import { fetchItavResTag, fetchNonItavResTag, createTag, updateTag } from '@/api/res_store/tag.js';
import MindMap from '@/components/MindMap/index.vue';
import { createVideoTag, getVideoTagList, updateVideoTag } from '@/api/system/video-tag';

export default {
  components: {
    MindMap: MindMap
  },

  props: {
    tagType: {
      type: String,
      default: ''
    },
    config: {
      type: Object
    }
  },

  data: function data() {
    return {
      /**
       * @type {{addible:boolean, children:[{}], deletable:false, editable:false, id:number, is_require:number, name:string, perm:number, pid:number, showIsRequired:boolean, sub_tags:[{}], type:number}}
       */
      tagTree: {},
      loading: false
    };
  },


  computed: {
    isResourceTag: function isResourceTag() {
      return (/resource-tag$/.test(this.tagType)
      );
    }
  },

  mounted: function mounted() {
    this.refreshTagTree();
  },


  methods: {
    getTagTree: function getTagTree(tagType) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var TagTypeUtils, res, tagTree;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                TagTypeUtils = {
                  'interactive-tag': getInteractiveTagList,
                  'noninteractive-tag': getNoninteractiveTagList,
                  'interactive-resource-tag': fetchItavResTag,
                  'noninteractive-resource-tag': fetchNonItavResTag,
                  'system-video-tag': getVideoTagList
                };


                _this.loading = true;

                _context.prev = 2;
                _context.next = 5;
                return TagTypeUtils[tagType]();

              case 5:
                res = _context.sent;
                tagTree = _get(res, 'data.data.tag');

                _this.cookTagTree(tagTree);
                _this.tagTree = tagTree;
                _this.loading = false;
                return _context.abrupt('return', true);

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](2);

                console.error(_context.t0);
                _this.loading = false;
                return _context.abrupt('return', false);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 13]]);
      }))();
    },
    refreshTagTree: function refreshTagTree() {
      var _this2 = this;

      this.getTagTree(this.tagType).then(function (res) {
        if (res) {
          setTimeout(function () {
            // 滚动到中间
            _this2.$refs['mind-map'] && _this2.$refs['mind-map'].alignCenter();
          }, 100);
        }
      });
    },
    cookTag: function cookTag(tag) {
      var _this3 = this;

      if (!tag) return null;

      var permissionUtils = {
        // - 1: 可增加子标签
        // - 2: 可修改标签
        // - 4: 可删除标签
        // 权限组合：权限值相加
        addible: {
          value: 1,
          permission: 'create'
        },
        editable: {
          value: 2,
          permission: 'update'
        },
        deletable: {
          value: 2, // 有 update 权限就有隐藏权限
          permission: 'delete'
        }

        // 根结点
      };if (tag.id === 0) {
        // 元素标签不可新增一级类目
        if (this.isResourceTag) {
          tag.perm = 0;
        } else {
          // id 为 0 代表是根结点，当新增一级标签时需要显示必填控件让用户选择
          tag.visibleOfIsRequiredFormItem = function (status) {
            return true;
          };
          // 强行将根结点的权限改为 1，可新增子节点
          tag.perm = 1;
        }
      } else if (tag.pid === 0) {
        // 一级节点
        // 一级节点新增节点时不需要显示必填控件让用户选择，只有编辑的时候需要
        // 只有编辑的时候需要
        tag.visibleOfIsRequiredFormItem = function (status) {
          if (status === 'edit') return true;
          return false;
        };
      } else {
        tag.visibleOfIsRequiredFormItem = function (status) {
          return false;
        };
      }

      // 拆解权限值，并给节点新增 addible/editable/deletable 属性
      var permission = _Object$keys(permissionUtils).map(function (key) {
        return {
          key: key,
          // add=1，update=2, delete=4, 对应二级制 1、2、3 位，检查是否有删除权限就用 if x & 4 > 0
          // eslint-disable-next-line no-bitwise
          value: (permissionUtils[key].value & tag.perm) > 0,
          permission: permissionUtils[key].permission
        };
      });
      // console.log(tag.perm, permission)
      // 检查该用户有没有分配这个权限
      permission = permission.map(function (item) {
        // 如果当前节点可被操作（新增/删除/编辑），就需要检查该用户有没有分配这个权限
        if (item.value) {
          return _extends({}, item, {
            value: _this3.hasPermission(_this3.config.permissionKey)
          });
        }
        return item;
      });
      permission.forEach(function (item) {
        return tag[item.key] = item.value;
      });

      tag.children = tag.sub_tags || [];

      return tag;
    },


    /**
     * 将接口的格式转换为适用 node-map 组件的格式
     * @param {{}|[]} tree
     */
    cookTagTree: function cookTagTree(tree) {
      var _this4 = this;

      if (_isPlainObject(tree)) {
        tree = this.cookTag(tree);
        Array.isArray(tree.children) && this.cookTagTree(tree.children);
      }

      if (Array.isArray(tree)) {
        tree.forEach(function (item) {
          return _this4.cookTagTree(item);
        });
      }
    },


    /**
     * @param {{child: {name: string, is_required?: number}}} params[0]
     * @param {function} onSuccess
     * @param {function} onFail
     */
    appendChild: function appendChild(_ref, onSuccess, onFail) {
      var node = _ref.node,
          id = _ref.id;

      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var TagTypeUtils, res, tag;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                TagTypeUtils = {
                  'interactive-tag': function interactiveTag() {
                    return createInteractiveTag(_extends({}, node, {
                      pid: id
                    }));
                  },
                  'noninteractive-tag': function noninteractiveTag() {
                    return createNoninteractiveTag(_extends({}, node, {
                      pid: id
                    }));
                  },
                  'interactive-resource-tag': function interactiveResourceTag() {
                    return createTag(_extends({}, node, {
                      pid: id
                    }));
                  },
                  'noninteractive-resource-tag': function noninteractiveResourceTag() {
                    return createTag(_extends({}, node, {
                      pid: id
                    }));
                  },
                  'system-video-tag': function systemVideoTag() {
                    return createVideoTag(_extends({}, node, {
                      pid: id
                    }));
                  }
                };
                _context2.prev = 1;
                _context2.next = 4;
                return TagTypeUtils[_this5.tagType]();

              case 4:
                res = _context2.sent;
                tag = _this5.cookTag(_get(res, 'data.data.tag'));


                _this5.recTree(_this5.tagTree, id, function (data) {
                  if (!Array.isArray(data.children)) {
                    data.children = [];
                  }
                  data.children.push(_extends({}, tag));
                  // 因为 tree 数据变更后会在 $nextTick 回调函数中更新布局，所以加 0 秒延迟让滚动到指定节点的操作放在更新布局之后
                  setTimeout(function () {
                    _this5.$refs['mind-map'].animateScrollTo(tag.id);
                  }, 0);
                  _this5.$message.success('新增标签成功');
                  onSuccess(_extends({}, tag));
                });
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](1);

                console.error(_context2.t0);
                onFail();

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[1, 9]]);
      }))();
    },
    removeNode: function removeNode(_ref2, onSuccess, onFail) {
      var id = _ref2.id,
          parentId = _ref2.parentId;

      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var TagTypeUtils, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                TagTypeUtils = {
                  'interactive-tag': function interactiveTag() {
                    return updateInteractiveTag({ id: id }, { is_hidden: 1 });
                  },
                  'noninteractive-tag': function noninteractiveTag() {
                    return updateNoninteractiveTag({ id: id }, { is_hidden: 1 });
                  },
                  'interactive-resource-tag': function interactiveResourceTag() {
                    return updateTag({ id: id, is_hidden: 1 });
                  },
                  'noninteractive-resource-tag': function noninteractiveResourceTag() {
                    return updateTag({ id: id, is_hidden: 1 });
                  },
                  'system-video-tag': function systemVideoTag() {
                    return updateVideoTag({ id: id, is_hidden: 1 });
                  }
                };
                _context3.prev = 1;
                _context3.next = 4;
                return TagTypeUtils[_this6.tagType]();

              case 4:
                res = _context3.sent;


                _this6.recTree(_this6.tagTree, parentId, function (data) {
                  data.children = data.children.filter(function (item) {
                    return item.id !== id;
                  });
                  _this6.$message.success('删除标签成功');
                  onSuccess();
                });
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](1);

                console.error(_context3.t0);
                onFail();

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[1, 8]]);
      }))();
    },
    updateAppTag: function updateAppTag(_ref3, onSuccess, onFail) {
      var id = _ref3.id,
          node = _ref3.node;

      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var TagTypeUtils, res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                TagTypeUtils = {
                  'interactive-tag': function interactiveTag() {
                    return updateInteractiveTag({ id: id }, _extends({}, node));
                  },
                  'noninteractive-tag': function noninteractiveTag() {
                    return updateNoninteractiveTag({ id: id }, _extends({}, node));
                  },
                  'interactive-resource-tag': function interactiveResourceTag() {
                    return updateTag(_extends({ id: id }, node));
                  },
                  'noninteractive-resource-tag': function noninteractiveResourceTag() {
                    return updateTag(_extends({ id: id }, node));
                  },
                  'system-video-tag': function systemVideoTag() {
                    return updateVideoTag(_extends({ id: id }, node));
                  }
                };
                _context4.prev = 1;
                _context4.next = 4;
                return TagTypeUtils[_this7.tagType]();

              case 4:
                res = _context4.sent;


                _this7.recTree(_this7.tagTree, id, function (data) {
                  data.name = node.name;
                  data.name_en = node.name_en;
                  if (typeof node.is_required !== 'undefined') {
                    data.is_required = node.is_required;
                  }
                  _this7.$message.success('更新标签成功');
                  onSuccess();
                });
                _context4.next = 12;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](1);

                console.error(_context4.t0);
                onFail();

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[1, 8]]);
      }))();
    },


    /**
     * @param {{}} data tag 对象
     * @param {number} id
     * @param {function} cb
     */
    recTree: function recTree(data, id, cb) {
      var _this8 = this;

      if (data.id === id) {
        cb(data);
        return;
      }
      if (data.children) {
        data.children.forEach(function (item) {
          _this8.recTree(item, id, cb);
        });
      }
    }
  }
};